// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.inner-content {
  background-color: var(--vl-bg-dark) !important;
  display: block;
  overflow-y: auto;
}

ion-slides {
  height: 100%;
}

.swiper-slide {
  padding: 30px;
}

ion-slides, ion-slide {
  display: block;
  overflow-y: auto;
}
ion-slides .slide, ion-slide .slide {
  width: 100%;
  display: flex;
  flex-flow: column;
}

ion-slide {
  padding: 30px;
  display: flex;
  align-items: flex-start;
}

vl-add-new-credit-card, vl-choose-free-hours {
  display: flex;
  flex-flow: column;
}

::ng-deep.custom-btn-block {
  justify-content: center;
  align-items: flex-end;
  margin: 16px 0;
}

::ng-deep.back-button-block.no-margin ion-button {
  width: auto;
  margin-left: 0 !important;
}
::ng-deep.back-button-block > div {
  display: flex;
}

@media (max-width: 576px) {
  ::ng-deep ion-modal.auto-height .modal-wrapper {
    height: 80% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/payment/pages/payment/payment.page.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,8CAAA;EACA,cAAA;EACA,gBAAA;AA0DF;;AAvDA;EACE,YAAA;AA0DF;;AAvDA;EACE,aAAA;AA0DF;;AAvDA;EAEE,cAAA;EACA,gBAAA;AAyDF;AAxDE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AA0DJ;;AApDA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;AAuDF;;AAnDA;EAEE,aAAA;EACA,iBAAA;AAqDF;;AAlDA;EAGE,uBAAA;EACA,qBAAA;EACA,cAAA;AAmDF;;AA9CI;EACE,WAAA;EACA,yBAAA;AAiDN;AA9CE;EACE,aAAA;AAgDJ;;AA5CA;EACE;IACE,sBAAA;EA+CF;AACF","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\n.inner-content {\n  background-color: var(--vl-bg-dark) !important;\n  display: block;\n  overflow-y: auto;\n  // max-height: none !important;\n}\nion-slides {\n  height: 100%;\n}\n\n.swiper-slide {\n  padding: 30px\n}\n\nion-slides, ion-slide {\n  // min-height: calc(100vh - #{$toolbar-height});\n  display: block;\n  overflow-y: auto;\n  .slide {\n    width: 100%;\n    display: flex;\n    flex-flow: column;\n    // min-height: calc(100vh - 80px);\n    //min-height: calc(100vh - #{$toolbar-height});\n  }\n}\n\nion-slide {\n  padding: 30px;\n  display: flex;\n  align-items: flex-start;\n}\n\n\nvl-add-new-credit-card, vl-choose-free-hours {\n  // min-height: calc(100vh - 80px - var(--ion-safe-area-top, 0));\n  display: flex;\n  flex-flow: column;\n}\n\n::ng-deep.custom-btn-block {\n  // flex: 1 1 auto;\n  // display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  margin: 16px 0;\n}\n\n::ng-deep.back-button-block {\n  &.no-margin {\n    ion-button {\n      width: auto;\n      margin-left: 0 !important;\n    }\n  }\n  & > div {\n    display: flex;\n  }\n}\n\n@media (max-width: 576px) {\n  ::ng-deep ion-modal.auto-height .modal-wrapper {\n    height: 80% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
